window.addEventListener("load", function () {
  // var header = document.getElementById("cfl-ms-25-header");
  // var loading = document.querySelector(".MS__layer-loading");

  // function triggerAnimation() {
  //   if (header) header.classList.add("ready");
  // }

  // if (!loading || !loading.classList.contains("active")) {
  //   triggerAnimation();
  // } else {
  //   var observer = new MutationObserver(function (mutations) {
  //     mutations.forEach(function (mutation) {
  //       if (mutation.attributeName === "class" && !loading.classList.contains("active")) {
  //         triggerAnimation();
  //         observer.disconnect();
  //       }
  //     });
  //   });
  //   observer.observe(loading, { attributes: true });
  // }
});